import React from 'react';
import dynamic from 'next/dynamic';
import {
  Box,
  Container,
  Divider,
  Grid,
  Hidden,
} from '@drivekyte/web-components';
import styled from 'styled-components';
import { Testimonial } from '@/components/growth/reviews/hooks/use-review-options/use-review-options';
import useTranslation from '@/hooks/use-translation';
import useReviewOptions from './hooks/use-review-options';

const SectionHeader = dynamic(() => import('../section-header'));
const Review = dynamic(() => import('./components/review'));

type ReviewProps = {
  reviews?: {
    primary?: string;
    success?: string;
    caption?: string;
    testimonials?: Array<Testimonial>;
  };
};

const Reviews = ({ reviews }: ReviewProps) => {
  const { t } = useTranslation('pages.welcome-page.reviews');
  const testimonials = useReviewOptions(reviews?.testimonials);

  return (
    <Container>
      <Box
        display="flex"
        flexDirection="row"
        paddingBottom="xxxxLarge"
        paddingTop="xxxxLarge"
      >
        <Grid container spacing={6}>
          <Grid item md={4} sm={12}>
            <SectionHeader
              primaryText={reviews?.primary || t('primary')}
              successText={reviews?.success || t('success')}
              captionText={reviews?.caption || t('caption')}
              noMargin
            />
          </Grid>
          <Grid container item md={8} xs={12} direction="row" spacing={1}>
            {testimonials.map(
              ({ title, platform, date, text, author, url }, index) => (
                <Box key={title}>
                  <Review
                    title={title}
                    platform={platform}
                    date={date}
                    text={text}
                    author={author}
                    url={url}
                  />
                  {index < testimonials.length - 1 && <ReviewDivider />}
                </Box>
              ),
            )}
          </Grid>
        </Grid>
      </Box>
      <Hidden smUp>
        <Divider />
      </Hidden>
    </Container>
  );
};

const ReviewDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.borderColors.primary};
  margin-top: ${({ theme }) => theme.spacings.xxxLarge}px;
  margin-bottom: ${({ theme }) => theme.spacings.xxxLarge}px;
`;

export default Reviews;
